import { shopCLient } from '@/services/axiosConfig'
import { AddToCartReq, CartRes } from './types'

export type AddToCartResp = CartRes

type AddToCart = (isdn: string, req: AddToCartReq) => Promise<AddToCartResp>

export const addToCart: AddToCart = async (isdn, req) => {
  try {
    const res = await shopCLient.post(`/service/add-cart?isdn=${isdn}`, req)

    return res.data.response
  } catch (e) {
    console.error(e)
  }
}
